<template>
  <div class="users-layout">
    <default-box
        :loader="loading">
      <label class="d-flex justify-content-start align-items-center  mb-10">
                <span class="default-input__label">
                  {{ $t('inputs.select_date') }}
                </span>
        <input type="date" id="start" name="trip-start"
               v-model="date"
               @change="fetchList">
      </label>

      <tables-slot
          :empty_spacer="loading"
          @paginationFetch="fillData"
          @popstateEvent="fetchList"
          :pagination="pagination">
        <template v-slot:table_head>
          <td class="w-0 text-nowrap">#</td>
          <td class="w-0 text-nowrap">Name</td>
          <td class="w-0 text-nowrap">{{ $t('reports.status') }}</td>
          <td class="w-0 text-nowrap">{{ $t('reports.country') }}</td>
          <td class="w-0 text-nowrap">{{ $t('reports.city') }}</td>
          <td class="w-0 text-nowrap">{{ $t('reports.veo_individual') }}</td>
          <td class="w-0 text-nowrap">{{ $t('reports.working') }}</td>
          <td class="w-0 text-nowrap">{{ $t('reports.the_reason_if_no') }}</td>
          <td class="w-0 text-nowrap">{{ $t('reports.date_of_work_renewal') }}</td>
          <td class="w-0 text-nowrap">{{ $t('reports.working_location') }}</td>
          <td class="w-0 text-nowrap">{{ $t('reports.electricity') }}</td>
          <td class="w-0 text-nowrap">{{ $t('reports.internet') }}</td>

        </template>
        <template v-slot:table_body>
          <tr v-for="item in list" :class="{ no_report: isReport(item) }">
            <td class="w-0 text-nowrap">
              {{ item.id }}
            </td>
            <td class="w-0 text-nowrap">
              {{ item.full_name}}<router-link-to
                class="d-inline-block px-10 py-10"
                :route_params="{id: item.id}"
                :route_name="route_names.user">
              <edit-icon/>
            </router-link-to>
            </td>
            <template v-if="item.report">
              <td class="w-0 text-nowrap">
                {{ item.report.status }}
              </td>
              <td class="w-0 text-nowrap">
                {{ item.report.country }}
              </td>
              <td class="w-0 text-nowrap">
                {{ item.report.city }}
              </td>
              <td class="w-0 text-nowrap">
                {{ item.report.veo_individual }}
              </td>
              <td class="w-0 text-nowrap">
                {{ item.report.working }}
              </td>
              <td class="w-0 text-nowrap">
                {{ item.report.the_reason_if_no }}
              </td>
              <td class="w-0 text-nowrap">
                {{ item.report.date_of_work_renewal }}
              </td>
              <td class="w-0 text-nowrap">
                {{ item.report.working_location }}
              </td>
              <td class="w-0 text-nowrap">
                {{ item.report.electricity }}
              </td>
              <td class="w-0 text-nowrap">
                {{ item.report.internet }}
              </td>
            </template>
            <template v-else>
              <td class="w-0 text-nowrap">

              </td>
              <td class="w-0 text-nowrap">

              </td>
              <td class="w-0 text-nowrap">

              </td>
              <td class="w-0 text-nowrap">

              </td>
              <td class="w-0 text-nowrap">

              </td>
              <td class="w-0 text-nowrap">

              </td>
              <td class="w-0 text-nowrap">

              </td>
              <td class="w-0 text-nowrap">

              </td>
              <td class="w-0 text-nowrap">

              </td>
              <td class="w-0 text-nowrap">

              </td>
            </template>
          </tr>
        </template>
      </tables-slot>
    </default-box>
  </div>
</template>

<script>

import calendar_mixin from "../../mixins/calendar_mixin";
import {axiosReport, axiosUsers} from "../../helpers/axios_requests";
import {GET_QUERY_OBJECT_VALUE, REPLACE_IN_QUERY, REPLACE_STATE} from "../../helpers/url_helper";
import routes_mixin from "../../mixins/routes_mixin";
import RouterLinkTo from "../small_components/RouterLinkTo";
import TablesSlot from "../small_components/tables/TablesSlot";
import Switcher from "../small_components/Switcher";
import EditIcon from "../icons/EditIcon";
import {mapGetters} from "vuex";
import DefaultBox from "../slots/DefaultBox";
import SearchInput from "../small_components/SearchInput";
import dateMixin from "../../mixins/dateMixin";

export default {
  name: 'DailyReportLayout',
  mixins: [calendar_mixin, routes_mixin, dateMixin],
  components: {
    SearchInput,
    DefaultBox,
    EditIcon,
    Switcher,
    TablesSlot,
    RouterLinkTo,
  },
  computed: {
    ...mapGetters([
      'getUserRoleIsAdmin'
    ])
  },
  beforeMount() {
    this.fetchList();
    this.search = GET_QUERY_OBJECT_VALUE('search', location.search);
    this.setDate();
  },
  data() {
    return {
      list: [],
      pagination: [],
      loading: false,
      search: '',
      date: null,
    }
  },
  methods: {
    searchFetchList(e) {
      this.search = e.target.value
      REPLACE_STATE(
          REPLACE_IN_QUERY(location.search, 'search', this.search)
      )
      this.fetchList()
    },
    setDate() {
      this.date = this.getDateFormatStr(new Date(), '-')
    },
    isReport(item) {
      return item.report == null;
    },
    fetchList() {
      this.loading = true
      axiosReport.list({date: this.date})
          .then(r => {
            this.fillData(r.data)
          })
          .finally(() => {
            this.loading = false
          })
    },
    fillData({collection, pagination}) {
      this.list = collection || []
      this.pagination = pagination || []
    },
    changeActive(item) {
      item.active = item.active ? 0 : 1
    },
  }
}
</script>
